// Laws that are brand new to the tracker in the 2026 update cycles (May + September 2026)
export const newIn2026 = new Set([
  // Federal
  "TAKE IT DOWN Act",
  "FTC COPPA Rule Amendments (2025)",
  "Kids Online Safety Act (KOSA) — S.1748",
  "Kids Internet and Digital Safety (KIDS) Act — H.R. 7757",
  "Children and Teens' Online Privacy Protection Act (COPPA 2.0)",
  "App Store Accountability Act (federal) — S.1586 / H.R. 3149",
  // Consumer Privacy
  "Louisiana Kids Online Protection & Anti-Grooming Act Amendments (HB 427 / Act 552)",
  // AADC
  "South Carolina Age-Appropriate Code Design Act (H. 3431)",
  "New Jersey Kids Code Act (A 4015)",
  // Social Media
  "Minnesota Social Media Mental Health Warning Labels",
  "Minnesota Stop Harms from Addictive Social Media Amendments (HF 4138)",
  "Virginia Social Media Screen Time Limits (SB 854 / VCDPA Amendment)",
  "Nevada Youth Online Safety Act (SB 63)",
  "Children's Social Media Safety Act (HB 5511)",
  "Kids Over Clicks — Youth Online Safety Package (SB 757-760)",
  "Pennsylvania Deepfake & Digital Impersonation Act (Act 35 of 2025)",
  "California Addictive Features Ban for Under-16s (AB 1709)",
  "Healthier Social Media Use by Youth Act (HB 24-1136)",
  "Idaho Stop Harms from Addictive Social Media Act (H 542)",
  "Indiana Youth Social Media Protections (HEA 1408)",
  "Mississippi Keeping Kids Safe Online Act (HB 1224)",
  "Nebraska Parental Rights in Social Media Act (LB 383)",
  "New York SAFE for Kids Act (Stop Addictive Feeds Exploitation)",
  "New York Social Media Warning Labels (S 4505 / A 5346)",
  "South Carolina Stop Harm from Addictive Social Media Act (HB 4591)",
  // App Store
  "Alabama App Store Accountability Act (HB 161)",
  "Colorado Age Attestation on Computing Devices (SB26-051)",
  // Age Verification
  "Age Verification for Harmful Content (HB 4412)",
  "Age Verification for Harmful Content (HF 864)",
  // AI Chatbot
  "California Companion AI Chatbot Safety Act (SB 243)",
  "California Adam's Law — Companion Chatbot Minor Protections (SB 1119)",
  "Colorado AI Companion Chatbot Safety Act (HB 26-1263)",
  "Connecticut AI Responsibility and Transparency Act — Chatbot Minor Protections (SB 5 / P.A. 26-15)",
  "Georgia AI Chatbot Disclosure and Child Safety Act (SB 540)",
  "Hawaii Artificial Intelligence Disclosure and Safety Act (SB 3001 / Act 248)",
  "Idaho Conversational AI Safety Act (SB 1297)",
  "Iowa Conversational AI Services Act (SF 2417)",
  "Maine Act to Regulate Children's Access to AI Chatbots (LD 2162)",
  "Nebraska Conversational AI Safety Act (LB 525)",
  "New York AI Companion Models Law (2025 Budget)",
  "New York Kids Chatbot Safety Act (S 9051 / A 10379)",
  "Oregon Companion Chatbot Safety Act (SB 1546)",
  "Rhode Island Companion Chatbot Safety Law (S 2195 / H 7350)",
  "Utah Companion Chatbot Safety Act (HB 438)",
  "Washington Companion Chatbot Minor Safety Act (HB 2225)",
  // International
  "Digital Statute for Children and Adolescents (Digital ECA / Law 15,211/2025)",
  "Online Safety (Relief and Accountability) Act 2025",
  "Digital Personal Data Protection Act — Children's Provisions",
  "Under-16 Social Media Ban (Children's Wellbeing and Schools Act 2026 regulations)",
  "EU Digital Minimum Age & Mandatory Age Assurance Initiative",
  "Under-15 Social Media Ban (2026 Law)",
  "Organic Law for the Protection of Minors in Digital Environments",
  "Social Media Minimum Age (Under 15)",
  "Social Media Ban for Under-15s",
  "Social Media Age Limit Bill",
  "Safe Social Media Act (Bill C-34)",
  "Online Safety Act 2025 — Under-16 Social Media Ban",
  "Under-16 Social Media Ban (PP Tunas Implementation)",
  "Draft Decree on Children Under 16 on Social Media",
  "Online Safety (Minimum Age and Child Safety Risk Assessment) Bill",
]);

// Laws already in tracker that had a significant status change or court ruling since the last update
export const updatedIn2026 = new Set([
  // Federal
  "TAKE IT DOWN Act",                                               // Platform removal duty live May 19, 2026
  "Kids Online Safety Act (KOSA) — S.1748",                         // Senate Commerce Aug 5, 2026
  // Consumer Privacy
  "Arkansas Children and Teens' Online Privacy Protection Act (HB 1717)", // Active July 1, 2026
  "Connecticut Data Privacy Act (Children's Privacy Amendments)",   // Phase 2 July 1, 2026
  "Nebraska Data Privacy Act & AADC (LB 504)",                      // LB 838 amendment July 17, 2026
  // Social Media
  "Social Media Safety Act (SB 396) & 2025 Amendments (Acts 900 / 901)", // Act 900 enjoined Apr 2026
  "Protecting Our Kids from Social Media Addiction Act (SB 976)",   // 9th Cir. Nov 2025
  "Online Protections for Minors (HB 3)",                           // 11th Cir. argued Mar 2026
  "Protecting Georgia's Children on Social Media Act (SB 351)",     // 11th Cir. argued Mar 2026
  "Secure Online Child Interaction and Age Limitation Act (SB 162 / Act 456)", // Struck down Dec 2025
  "Walker Montgomery Protecting Children Online Act (HB 1126)",     // 5th Cir. argued Feb 2026
  "Parental Notification by Social Media Operators Act",            // 6th Cir. June/Aug 2026
  "Tennessee Protecting Children from Social Media Act",            // 6th Cir. Aug 28, 2026
  "Securing Children Online Through Parental Empowerment Act (SCOPE / HB 18)", // 5th Cir. July 2026
  "Utah Minor Protection in Social Media Act (SB 194)",             // 10th Cir. pending
  // AADC
  "California Age-Appropriate Design Code Act (AB 2273)",           // Remand; AB 2246
  "Maryland Age-Appropriate Design Code Act (Kid's Code)",          // MTD denied
  "Nebraska Age-Appropriate Online Design Code Act (LB 504, amended by LB 838)",
  "Vermont Age-Appropriate Design Code Act",                        // NetChoice challenge
  // App Store
  "Texas App Store Accountability Law (SB 2420)",                   // 5th Cir. stay; SCOTUS denial
  "Utah App Store Accountability Act (SB 142, amended by HB 498)",  // Delayed to 2027
  "Louisiana App Store Accountability Law (HB 977, replacing Act 481 / HB 570)", // Delayed to 2027
  // Age Verification
  "Age Verification for Harmful Content (Rule + HB 1839)",          // Missouri statute Aug 2026
  "Age Verification for Harmful Content (HB 1181)",                 // 27-state count
  // International
  "Social Media Minimum Age Law",                                   // Australia enforcement phase
  "Digital Services Act — Guidelines on Protecting Minors",         // TikTok/Meta actions 2026
  "Online Safety Act — Child Safety Regime",                        // Ofcom review
]);
